export default {
  "content": "<path d=\"M19.53 3.618l-3.73-1.41-9.41 3.98v4.39l-2.22-.86v-4.38l9.43-4-3.41-1.3a.5.5 0 00-.38 0L.47 3.558c-.29.11-.47.38-.47.69v10.95c0 .3.18.57.45.68l9.58 4.09c.26 0 8.09-3.45 9.69-4.16.17-.08.28-.25.28-.44V4.307c0-.3-.19-.58-.47-.69z\" fill=\"#C70A14\"/>",
  "attrs": {
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};